module.exports = __webpack_public_path__ + "static/media/Reportage.22a07b87.avi";